import generalSection from "../_section/section.class";
import {adminBookingDepositReceiptUpload, userBookingDepositReceiptUpload} from "./upload";
import DataForm from "./DataForm";
import problem from "../_section/section-problem.class";

export class userBookingDepositReceiptSection extends generalSection {
    constructor(request, mortgage, props, statementUploadFactory = null) {
        super(request, mortgage, props, statementUploadFactory ?? userBookingDepositReceiptUpload);
        // Add missing date error

    }
}

export class adminBookingDepositReceiptSection extends userBookingDepositReceiptSection {
    constructor(request, mortgage, props) {
        super(request, mortgage, props, adminBookingDepositReceiptUpload);
        this.DataForm = DataForm
        this.sortByDateProp('documentDate');
        this.activeUpload = this.uploads.find(u => u.allValuesAnswered && u.isVerifiable)
        this.setProblems(this.getProblems())
    }

    getProblems() {
        const problems = this.problemsList.singleUploadUserProblems();
        if (!problems.length) {
            const sum = this.activeUploads.reduce((acc, upload) => {
                if (upload.values.amount) {
                    return acc + parseFloat(upload?.values?.amount || 0);
                }
                return acc;
            }, 0)
            // Amount Mismatch
            const applicationAmount = this.mortgage.property.bookingDepositPaid
            if (sum && applicationAmount && sum !== applicationAmount) {
                problems.push(new problem({
                    type: 'BUNDLE',
                    title: 'Data Mismatch',
                    reason: 'Application amount doesnt match the upload',
                    uploadIDs: this.activeUploads.map(u => u.id),
                    message: `${sum} does not match the application amount (${applicationAmount})`,
                }))
            }
        }
        return problems
    }

    get amount() {
        if (this.activeUpload && this.activeUpload.values.amount) {
            return this.activeUpload.values.amount;
        }
        return null;
    }

    getSectionSummary = () => {
        return [
            {
                name: this.personalTitle,
                tags: [{
                    name: 'Dated',
                    value: this.activeUpload?.values?.documentDate?.format('D MMM YYYY') || 'Not Provided',
                }, {
                    name: 'Amount',
                    value: this.activeUpload?.values?.amount || 'Not Provided',
                }]
            }
        ]
    }
}